// icons
import { 
  MdCategory, 
  MdList, 
  MdPerson, 
  MdStraighten, 
  MdInventory, 
  MdLocalShipping, 
  MdStorefront, 
  MdMap, 
  MdAccountBalance,
  MdSupervisorAccount,
  MdFlag
 } from "react-icons/md";

const catalogos = {
  id: 'catalogos-group',
  type: 'group',
  roles: [1,100,110,200],
  breadcrumbs: false,
  children: [
    {
      id: 'catalogos',
      title: "Catálogos",
      type: 'collapse',
      icon: MdCategory,
      children: [
        {
          id: 'catalogos-usuarios',
          title: "Usuarios",
          type: 'item',
          breadcrumbs: false,
          icon: MdPerson,
          url: '/catalogos/usuarios',
          roles: [1,100,110]
        },
        {
          id: 'catalogos-clientes-especialidad',
          title: "Clientes especialidad",
          type: 'item',
          breadcrumbs: false,
          icon: MdSupervisorAccount,
          url: '/catalogos/clientes-especialidad',
          roles: [1,100,110]
        },
        {
          id: 'catalogos-gastos',
          title: "Conceptos de Gastos",
          type: 'item',
          breadcrumbs: false,
          icon: MdList,
          url: '/catalogos/gastos',
          roles: [1,100,110]
        },
        {
          id: 'condiciones-pago',
          title: "Condiciones de Pago",
          type: 'item',
          breadcrumbs: false,
          icon: MdList,
          url: '/catalogos/condiciones-pago',
          roles: [1,100,110]
        },
        {
          id: 'cuentas-contables',
          title: "Cuentas Contables",
          type: 'item',
          breadcrumbs: false,
          icon: MdAccountBalance,
          url: '/catalogos/cuentas-contables',
          roles: [1,100,110]
        },
        {
          id: 'catalogos-insumos',
          title: "Insumos",
          type: 'item',
          breadcrumbs: false,
          icon: MdInventory,
          url: '/catalogos/insumos',
          roles: [1,100,110]
        },
        {
          id: 'catalogos-proveedores',
          title: "Proveedores",
          type: 'item',
          breadcrumbs: false,
          icon: MdLocalShipping,
          url: '/catalogos/proveedores',
          roles: [1,100,110,200]
        },
        {
          id: 'catalogos-unidades',
          title: "Unidades",
          type: 'item',
          breadcrumbs: false,
          icon: MdStraighten,
          url: '/catalogos/unidades',
          roles: [1,100,110,200]
        },
        {
          id: 'catalogos-vendedores',
          title: "Vendedores",
          type: 'item',
          breadcrumbs: false,
          icon: MdStorefront,
          url: '/catalogos/vendedores',
          roles: [1,100,110]
        },
        {
          id: 'catalogos-zonas-ventas',
          title: "Zonas de Ventas",
          type: 'item',
          breadcrumbs: false,
          icon: MdMap,
          url: '/catalogos/zonas-ventas',
          roles: [1,100,110]
        },
        
        {
          id: 'catalogos-objetivos-venta',
          title: "Objetivos venta",
          type: 'item',
          breadcrumbs: false,
          icon: MdFlag,
          url: '/catalogos/objetivos-venta',
          roles: [1,100,110]
        }
      ]
    }
  ]
};

export default catalogos;
